// Types each phrase out, pauses, deletes it, then moves on to the next one.
// Static (first phrase, no animation) when the visitor prefers reduced motion.
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class TypewriterHeadline extends HTMLElement {
  connectedCallback() {
    this.target = this.querySelector('[data-typewriter-text]');
    this.phrases = (this.dataset.phrases || '').split(',').map((p) => p.trim()).filter(Boolean);
    if (!this.target || this.phrases.length === 0 || reducedMotion.matches) return;
    this.index = 0;
    this.length = this.phrases[0].length;
    this.deleting = false;
    this.timer = setTimeout(() => this.tick(), 2200);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  tick() {
    const phrase = this.phrases[this.index];
    let delay = this.deleting ? 35 : 75;
    if (this.deleting) {
      this.length = Math.max(0, this.length - 1);
    } else {
      this.length = Math.min(phrase.length, this.length + 1);
    }
    // Slice by code points so emoji are never cut in half.
    this.target.textContent = Array.from(phrase).slice(0, this.length).join('');
    if (!this.deleting && this.length >= Array.from(phrase).length) {
      this.deleting = true;
      delay = 2200;
    } else if (this.deleting && this.length === 0) {
      this.deleting = false;
      this.index = (this.index + 1) % this.phrases.length;
      delay = 400;
    }
    this.timer = setTimeout(() => this.tick(), delay);
  }
}

if (!customElements.get('typewriter-headline')) {
  customElements.define('typewriter-headline', TypewriterHeadline);
}
